import { render } from "./GroupFullCard.vue?vue&type=template&id=7bc6d69d"
import script from "./GroupFullCard.vue?vue&type=script&lang=js"
export * from "./GroupFullCard.vue?vue&type=script&lang=js"

import "./GroupFullCard.vue?vue&type=style&index=0&id=7bc6d69d&lang=scss"

import exportComponent from "/home/misha/Рабочий стол/embody-system-front-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__